import React from 'react'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { SupportPage } from 'experiences/support'

const Support: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<SupportPage />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default Support
